import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import accountReceivable from './modules/accountReceivable'
import accountPayable from './modules/accountPayable'
import api from './modules/api'
import schedule from './modules/schedule'
import memberShip from './modules/memberShip'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        count: 0
    },
    mutations: {
        increment(state) {
            state.count++
        }
    },
    modules: {
        app,
        api,
        accountReceivable,
        accountPayable,
        schedule,
        memberShip,
    }
})

